import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Gallery } from './components/Gallery';
import { Transformation } from './components/Transformation';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = false
}: AppProps) {
  useMetaPixel();
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23w4g45bdvc2y">
      <div className="w-full bg-white" data-id="element-1" data-mp="23v2sl1d6kx4c">
        <main data-id="element-2" data-mp="3ik7e6ay3c1o0">
          <Hero data-id="element-3" data-mp="3ikqyfyb7r257" />
          <ProofBar data-id="element-4" data-mp="3ij63w8owfj7c" />
          <Problem data-id="element-5" data-mp="3ijpe138b53at" />
          <Gallery data-id="element-6" data-mp="3ii4q3wgi0ilx" />
          <Transformation data-id="element-7" data-mp="3ml14tc2x3ukl" />
          <WhatYouGet data-id="element-8" data-mp="3mkhofzsx1e8o" />
          <Bonuses data-id="element-9" data-mp="3mjq2zht18ww4" />
          <Pricing data-id="element-10" data-mp="3mj6j3vjtnyfg" />
          <Testimonials data-id="element-11" data-mp="3rcj31sdk3h1v" />
          <Guarantee data-id="element-12" data-mp="3rdaselgk8ijp" />
          <Faq data-id="element-13" data-mp="3rcsuzli5vya7" />
        </main>
        <Footer data-id="element-14" data-mp="5yjsutqtdfe" />
        {showPurchaseNotifications && <PurchaseToast data-id="element-15" data-mp="4n4bxqxqh8g" />}
      </div>
    </MotionConfig>;
}